export const ENVIRONMENT = 'development' //production | development
export const TOKEN_KEY = ENVIRONMENT === 'production' ? '_us_token' : '_us_token_dev'
export const SITE_KEY = ENVIRONMENT === 'production' ? '6Ld00sEiAAAAAL4O1RtqjtwWte2TWh77_JwgKX5y' : '6Ld00sEiAAAAAL4O1RtqjtwWte2TWh77_JwgKX5y'

export const API_ENDPOINT = ENVIRONMENT === 'production' ? 'https://ultimasearch.com/' : 'https://stage.ultimasearch.com/'
export const IDLE_TIME_IN_SECONDS = 300

export const ENCRYPT_AND_DECRYPT_KEY = 'wjEXA38AgXM1FWTxojcsBqykcV9NpX3h' 
export const DATA_VECTOR = 'dGEBTb1YQszEhk5G' 